import React, {Component} from 'react';
import { Table } from 'semantic-ui-react'
import _ from 'lodash'
//import TestData from './data'
import ErrorMessage from '../ErrorMessage'
import {client} from '../../Client';
import ElaboraButton from '../ElaboraButton'
import {minutesToHuman} from '../../Helpers'
import FileSaver from 'file-saver';
import PdfButton from '../PdfButton'
import ReddittivitaCommesse from '../../pdf/ReddittivitaCommesse'
import PropTypes from 'prop-types';
import ShowLocalNumber from "../ShowLocalNumber";

class ReportReddittivitaCommesse extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: undefined,
            filterInfo: {
            },
            _loading: false,
            error: null,
            column: null,
            direction: null,
        };
        this.onExportClick = this.onExportClick.bind(this)
        this.pdfExport = this.pdfExport.bind(this)
        this.loadData = this.loadData.bind(this)
    }

    pdfExport(){
        let ce = new ReddittivitaCommesse();
        ce.setTitle("Report Reddittività Commesse");
        ce.setFileName("report-reddittivita-commesse.pdf");
        ce.setOrientationLandscape();
        ce.setFilterDescription(this.getFilterDescription());
        ce.createPdf(this.state.items);
    }

    getFilterDescription(){
        let msg = 'Commesse con flag inRendicondazione = 1, con ore di attività lavorate.';
        return msg;
    }
    componentWillUnmount() {
    }

    componentDidMount() {
    }


    handleSort = clickedColumn => () => {
        const { column, items, direction } = this.state;
        if (column !== clickedColumn) {
            this.setState({
                column: clickedColumn,
                items: _.sortBy(items, [clickedColumn]),
                direction: 'ascending',
            });
            return;
        }
        this.setState({
            items: items.reverse(),
            direction: direction === 'ascending' ? 'descending' : 'ascending',
        })
    };

    loadData() {

        let filterInfo = this.state.filterInfo;
        this.setState({_loading: true});
        client.loadReportReddittivitaCommesse().then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        items: data.items,
                        total: data.total,
                        filterInfo: filterInfo,
                        _loading: false,
                        error: null
                    })
                })
            }
            else if (response.status === 401)
            {
                this.context.router.transitionTo("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });
    }

    onExportClick(tipo){
        let filterInfo = this.state.filterInfo;
        this.setState({_loading: true});
        client.exportReportReddittivitaCommesse(tipo).then((response) => {
            if (response.ok){
                response.blob().then((blob) => {
                    this.setState({_loading: false, error: null})
                    FileSaver.saveAs(blob, 'report_reddittivita_commesse.'+tipo);
                })
            }
            else if (response.status === 401)
            {
                this.context.router.transitionTo("/login")
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });
        });
    }

    render() {
        let i = 1;
        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} onDismiss={()=>{this.setState({error:null})}}/>)
        }
        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                <div className="ui loader"></div>
                </div>
            );
        }

        let numAttivitaTot = 0;
        let entrateTot = 0;
        let usciteTot = 0;
        let durataPesataTot = 0;
        let tableData = null;
        let stampaButton = null;
        let exportExcelButton = null;
        let exportPdfButton = null;
        if (this.state.items !== undefined){
            if (this.state.items.length > 0){
                // stampaButton = <PrintButton/>
                exportExcelButton = (<a href="#" onClick={(ev) => (this.onExportClick('xlsx'))}>
                    <div className="ui left floated small primary labeled icon button">
                        <i className="file excel outline icon"></i> Excel
                    </div>
                </a>)
                exportPdfButton = (<PdfButton onClick={(ev) => (this.pdfExport())} />)
                tableData = (
                    <div className="ui segment">
                        <h4>Report Reddittività</h4>
                        <p>
                            Commesse con flag inRendicontazione == 1 e con almeno un' attività lavorata.
                        </p>
                        <Table celled>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell sorted={this.state.column === 'idCommessa' ? this.state.direction:null} >
                                        Commessa
                                    </Table.HeaderCell>
                                    <Table.HeaderCell sorted={this.state.column === 'codiceCommessa' ? this.state.direction : null} >
                                        Codice
                                    </Table.HeaderCell>
                                    <Table.HeaderCell sorted={this.state.column === 'nomeCommessa' ? this.state.direction : null} >
                                        Nome
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign='center' sorted={this.state.column === 'sommaTotaleEntrate' ? this.state.direction:null} >
                                        Entrate
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign='center' sorted={this.state.column === 'sommaTotaleUscite' ? this.state.direction:null} >
                                        Uscite
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign='center' sorted={this.state.column === 'numeroAttivita' ? this.state.direction:null} >
                                        Numero Attività
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign='center' sorted={this.state.column === 'sommaDurataPesata' ? this.state.direction:null} >
                                        Durata Totale (h:m)
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign='center' sorted={this.state.column === 'reddittivita' ? this.state.direction:null} >
                                        Reddittività
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {
                                    this.state.items.map((item) => {
                                        numAttivitaTot += item.numeroAttivita;
                                        entrateTot += item.sommaTotaleEntrate;
                                        usciteTot += item.sommaTotaleUscite;
                                        durataPesataTot += item.sommaDurataPesata;
                                        return <Table.Row key={i++}>
                                            <Table.Cell><label className="ui empty circular label" style={{backgroundColor: item.coloreCommessa}}></label> {item.idCommessa}</Table.Cell>
                                            <Table.Cell>{item.codiceCommessa}</Table.Cell>
                                            <Table.Cell>{item.nomeCommessa}</Table.Cell>
                                            <Table.Cell  textAlign='center'><ShowLocalNumber value={item.sommaTotaleEntrate}/></Table.Cell>
                                            <Table.Cell  textAlign='center'><ShowLocalNumber value={item.sommaTotaleUscite}/></Table.Cell>
                                            <Table.Cell  textAlign='center'><ShowLocalNumber value={item.numeroAttivita} type=""/></Table.Cell>
                                            <Table.Cell  textAlign='center'>{minutesToHuman(item.sommaDurataPesata)}</Table.Cell>
                                            <Table.Cell  textAlign='center'><ShowLocalNumber value={item.reddittivita} type="decimal"/></Table.Cell>
                                        </Table.Row>
                                    })}
                            </Table.Body>
                            <Table.Footer>
                                <Table.Row>
                                    <Table.HeaderCell colSpan="3">Totali</Table.HeaderCell>
                                    <Table.HeaderCell  textAlign='center'><b><ShowLocalNumber value={entrateTot}/></b></Table.HeaderCell>
                                    <Table.HeaderCell  textAlign='center'><b><ShowLocalNumber value={usciteTot}/></b></Table.HeaderCell>
                                    <Table.HeaderCell  textAlign='center'><b><ShowLocalNumber value={numAttivitaTot} type=""/></b></Table.HeaderCell>
                                    <Table.HeaderCell  textAlign='center'><b>{minutesToHuman(durataPesataTot)}</b></Table.HeaderCell>
                                    <Table.HeaderCell  textAlign='center'></Table.HeaderCell>
                                </Table.Row>
                            </Table.Footer>
                        </Table>
                    </div>
                )
            }
            else {
                tableData = (
                    <div className="ui segment">
                        <h4>Reddittività Commesse</h4>
                        <p>
                            Commesse con flag inRendicontazione == 1 e con almeno un' attività lavorata.
                        </p>
                        <Table celled>
                            <Table.Body>
                                <Table.Row key={1}>
                                    <Table.Cell><h4>Nessun dato disponibile</h4></Table.Cell>
                                </Table.Row>
                            </Table.Body>
                            <Table.Footer>
                            </Table.Footer>
                        </Table>

                    </div>
                )
            }
        }


        return (<div className="ui">
            <h3 className="ui top block attached header no-print">
                <i className="shopping bag icon"/> Report Reddittività Commesse
            </h3>
            <div className="ui attached segment no-print">
            <div className="ui one column stackable grid">
                <div className="column">
                    <ElaboraButton text="Elabora" onClick={this.loadData} /> {stampaButton} {exportExcelButton} {exportPdfButton}
                </div>
            </div>
            </div>

            {tableData}
            {loader}
        </div>)
    }
}

ReportReddittivitaCommesse.contextTypes = {
    router: PropTypes.object
}

export default ReportReddittivitaCommesse;




/** WEBPACK FOOTER **
 ** ./src/components/report/ReportReddittivitaCommesse.js
 **/